import { t } from 'ttag'
import { mapValues } from 'utils/object'
import { getNormalizedScore } from 'utils/score'

const WARM_UP_PAGE = 'warmup'
const COOL_DOWN_PAGE = 'cooldown'

const CREATED = 'CREATED'
const INVITED = 'INVITED'
const IN_PROGRESS = 'IN_PROGRESS'
const SUBMITTED = 'SUBMITTED'

type AssessmentValues = {
  comment?: unknown
  score?: number | null
}

type AssessmentComments = {
  comments?: Record<string, string> | null
}

export const ASSESSMENT_GROUP_FIELD = 'evaluators'
export const COMMENT_FIELD = 'comment'
export const SCORE_FIELD = 'score'

export const STATIC_PAGES = [WARM_UP_PAGE, COOL_DOWN_PAGE]

export const SKILL_RANGE = 7

export const getEvaluations = status => ({
  [CREATED]: {
    key: CREATED,
    name: t`Created`,
    isActive: status === 1,
    isDone: status >= 1,
  },
  [INVITED]: {
    key: INVITED,
    name: t`Invited`,
    isActive: status === 2,
    isDone: status >= 2,
  },
  [IN_PROGRESS]: {
    key: IN_PROGRESS,
    name: t`In progress`,
    isActive: status === 3,
    isDone: status >= 3,
  },
  [SUBMITTED]: {
    key: SUBMITTED,
    name: t`Submitted`,
    isActive: status === 4,
    isDone: status >= 4,
  },
})

export const getSkillTitles = skills =>
  Object.fromEntries(skills.map(({ key, title }) => [key, title]))

export const getDefaultValues = () => ({
  [ASSESSMENT_GROUP_FIELD]: [],
})

export const getValues = ({
  assessments,
}: {
  assessments?: Record<string, AssessmentValues> | null
}) => ({
  [ASSESSMENT_GROUP_FIELD]: Object.entries(assessments ?? {}).map(
    ([key, { comment, score }]) => ({
      comment,
      key,
      score: getNormalizedScore(SKILL_RANGE)(score),
    }),
  ),
})

export const getQuestionComments = ({
  assessments,
}: {
  assessments?: Record<string, AssessmentComments | null> | null
} = {}): Record<string, Record<string, string>> => {
  const emptyComments: Record<string, string> = {}
  return mapValues(
    assessments ?? {},
    assessment => assessment?.comments ?? emptyComments,
  )
}
